<template>
  <div class="alert-container">
    <transition-group name="scroll-y-transition">
      <v-alert
        v-for="alert in currentAlerts"
        :key="alert.id"
        class="alert text-center"
        :value="!!alert.message"
        :dismissible="alert.dismissible"
        @input="closeAlert(alert)"
        dense
        v-model="alert.show"
        >{{ alert.message }}</v-alert
      >
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentAlerts"])
  },

  methods: {
    closeAlert(item) {
      item.show = false;
      this.$store.commit("removeAlert", item.id);
      return true;
    }
  },
  watch: {
    currentAlerts(newVal) {
      for (let index = 0; index < newVal.length; ++index) {
        let item = newVal[index];
        if (item.timeout) {
          setTimeout(() => {
            this.closeAlert(item);
          }, item.timeout);
        }
      }
    }
  }
};
</script>

<style>
.alert-container {
  position: fixed;
  margin: 0 5%;
  width: 90%;
  z-index: 1000000000;
}
</style>
